import React, { FC, useContext, useState } from 'react';
import injectSheet from 'react-jss';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useQuery } from '@apollo/react-hooks';

// Context
import UserDetailsContext from 'Context/userDetailsContext';

// GraphQL

// Components
import ListMembership from 'Components/ListMembership';
import { calculateRange, calcCurrentPage } from 'Components/Paging';
import { Loading } from 'Components/Loading';
import withErrorBoundary from 'HOC/ErrorBoundary';
import { listMembershipGql, profileHeaderGql } from './gqlQuery';

// Styles
import styleSheet from './styles';

interface Props {
  audience_key?: string; //eslint-disable-line
  classes: any;
}

const ListMembershipContainer: FC<Props> = ({
  classes,
  audience_key, //eslint-disable-line
}: Props) => {
  const recordsPerPage: number = 5;

  // User signed in data
  const userDetails = useContext(UserDetailsContext);

  // Container state
  const [listMemberShip, setListMemberShip] = useState({
    page: 1,
    totalPages: 0,
    totalRecords: 0,
    lists: undefined,
  });

  const [paging, setPaging] = useState({
    position: 'right',
    page: 1, // Update with the paging method
    recordsPerPage: 5, // 5 by default.  But if totalReacords are less than 5, then make it that value
    totalRecords: 0, // Update, based on how many lists come from graphql
    start: 0, // Update with the paging method
    end: 5, // Update with the paging method
    totalPages: 0,
  });

  const updatePaging = (
    page: number,
    totalRecords: number,
    totalPages?: number
  ) => {
    // Update Paging
    const calcRangeData = {
      page,
      recordsPerPage,
      totalRecords,
    };
    const { start, end } = calculateRange(calcRangeData);
    setPaging({
      ...paging,
      page,
      totalRecords,
      start,
      end,
      totalPages: totalPages || listMemberShip.totalPages,
    });
  };

  // GraphQL Queries
  const {
    loading,
    error,
    data: listMembershipData,
  } = useQuery(listMembershipGql, {
    variables: {
      inst_id: userDetails.instId,
      account_id: userDetails.accountId,
      user_key: audience_key,
      page: paging.page,
      size: recordsPerPage,
      sort: 'createdAt:desc',
    },
    fetchPolicy: 'cache-and-network',
    onCompleted: (data) => {
      const { page, totalPages, totalRecords, lists } =
        data.audienceListMemberShip;

      // Update the listMemberShip obj
      setListMemberShip({ page, totalPages, totalRecords, lists });

      // Update Paging
      updatePaging(page, totalRecords, totalPages);
    },
  });

  const { data: profileHeaderData } = useQuery(profileHeaderGql, {
    variables: {
      inst_id: userDetails.instId,
      audience_key,
    },
  });

  // Methods
  const onPrevPage = () => {
    const currentPage = calcCurrentPage(
      paging.page,
      listMemberShip.totalPages,
      -1
    );

    updatePaging(currentPage, paging.totalRecords);
  };

  const onNextPage = () => {
    const currentPage = calcCurrentPage(paging.page, listMemberShip.totalPages);

    updatePaging(currentPage, paging.totalRecords);
  };

  return (
    <div style={{ position: 'relative' }}>
      {loading && (
        <div className={classes.loaderHolder}>
          <Loading />
        </div>
      )}
      {listMembershipData && profileHeaderData && (
        <div style={{ opacity: loading ? 0.3 : 1 }}>
          <ListMembership
            lead={`${profileHeaderData.audience.audience.profile.firstName} ${profileHeaderData.audience.audience.profile.lastName}`}
            lists={listMemberShip.lists}
            paging={paging}
            pagingPrev={onPrevPage}
            pagingNext={onNextPage}
            error={error}
          />
        </div>
      )}
    </div>
  );
};
ListMembershipContainer.defaultProps = { audience_key: '' };
export default withErrorBoundary(
  injectSheet(styleSheet)(ListMembershipContainer)
);
